export default "__VITE_ASSET__ZgA6HYXT__"